import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import './bookingstable.css';

const BookingsTable = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBookings = async () => {
        setLoading(true);

        const { data, error } = await supabase
            .from('ticket_orders')
            .select('*')
            .order('id', { ascending: false });

        console.log('Supabase data:', data);
        console.log('Supabase error:', error);

        if (error) {
            setError(error.message);
            setBookings([]);
        } else {
            setBookings(data || []);
            setError(null);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchBookings();
    }, []);

    const deleteBooking = async (id) => {
        const confirmDelete = window.confirm("Delete this booking?");
        if (!confirmDelete) return;

        const { error } = await supabase
            .from('ticket_orders')
            .delete()
            .eq('id', id);

        if (error) {
            alert(error.message);
            return;
        }

        setBookings(prev => prev.filter(b => b.id !== id));
    };

    if (loading) {
        return (
            <div className="bookingstable">
                <p>Loading bookings...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bookingstable">
                <p style={{ color: 'red' }}>Error: {error}</p>
            </div>
        );
    }

    return (
        <div className="bookingstable">

            <div className="etopbar">
                <h6 className="tabletitle">Bookings</h6>
            </div>

            <div className="tableheader">
                <p>Name</p>
                <p>Email</p>
                <p>Phone</p>
                <p>Event</p>
                <p>Price</p>
                <p>Actions</p>
            </div>

            {bookings.length === 0 ? (
                <p style={{ padding: '10px' }}>No bookings found.</p>
            ) : (
                bookings.map((b) => (
                    <div className="tablerrow" key={b.id}>
                        <p>{b.name}</p>
                        <p>{b.email}</p>
                        <p>{b.phone}</p>
                        <p>{b.title}</p>
                        <p>{b.price}</p>

                        <div className="actions">
                            <button onClick={() => deleteBooking(b.id)}>
                                Delete
                            </button>
                        </div>
                    </div>
                ))
            )}

        </div>
    );
};

export default BookingsTable;